import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FileUserRequest, FileUserResponse } from '../models/drive.model';
import { EnvironmentService } from 'experian-shared-frontend';

@Injectable({
  providedIn: 'root',
})
export class DriveService {
  constructor(
    private http: HttpClient,
    public environmentService: EnvironmentService
  ) {}


  generateFileUrl(
    fileUserRequest: FileUserRequest[]
  ): Observable<FileUserResponse[]> {
    const basePath = `${this.environmentService.env.source}/digital/drive/v1`;
    const accessToken = localStorage.getItem('accessToken');
    const headers = this.simpleHeaders.append(
      // eslint-disable-next-line
      'Authorization', //NOSONAR
      `Bearer ${accessToken}`
    );

    return this.http.post<FileUserResponse[]>(
      `${basePath}/files/generate-url`,
      fileUserRequest,
      { headers }
    );
  }

  private get simpleHeaders(): HttpHeaders {
    return new HttpHeaders({ 'Content-Type': 'application/json' });
  }
}
